
import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend, Cell } from "recharts";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";

type CO2ByType = {
  rideType: string;
  totalCO2: number;
  totalDistance: number;
};

type Props = {
  data: CO2ByType[];
  periodLabel: string;
};

const COLORS = ["#00C49F", "#FF8042", "#0088FE", "#FFBB28", "#8884d8"];

const CO2ByTypeChart: React.FC<Props> = ({ data, periodLabel }) => {
  const sortedData = [...data].sort((a, b) => b.totalCO2 - a.totalCO2);

  return (
    <Card>
      <CardHeader>
        <CardTitle>CO₂ Offset by Ride Type</CardTitle>
        <CardDescription>
          Estimated CO₂ saved for each ride type ({periodLabel})
        </CardDescription>
      </CardHeader>
      <CardContent className="h-[300px]">
        {data.length === 0 ? (
          <div className="flex h-full items-center justify-center text-muted-foreground">No data available</div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={sortedData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="rideType" />
              <YAxis label={{ value: "kg CO₂", angle: -90, position: "insideLeft" }} />
              <Tooltip 
                formatter={(value: number) => [`${value.toFixed(2)} kg`, 'CO₂ Saved']}
                labelFormatter={(label) => `Ride Type: ${label}`}
              />
              <Legend />
              <Bar dataKey="totalCO2" name="CO₂ Saved (kg)">
                {sortedData.map((entry, idx) => (
                  <Cell key={`cell-co2-${idx}`} fill={COLORS[idx % COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default CO2ByTypeChart;
